<style lang="less">
  .table {
    .table-time {
      font-size: 12px;
    }
    .el-image .image-slot {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      background: #f5f7fa;
      color: #909399;
      font-size: 14px;
    }
  }
</style>

<template>
  <el-card>
    <div slot="header">
      <h1>{{ activity ? '“' + activity.activityName + '”' : '' }}页面设置</h1>
    </div>
    <el-tabs type="card" v-model="tabName" @tab-click="handleClick" :before-leave="handleLeave">
      <el-tab-pane label="首页显示设置" name="home-show">首页显示设置</el-tab-pane>
      <el-tab-pane label="轮播图" name="carousel-list">
        <div style="padding: 0 20px">
          <el-form inline :model="query" class="filter-form" style="position: relative">
            <el-form-item label="轮播图名称：">
              <el-input v-model="query.name" placeholder="请输入" :clearable="true" style="width: 300px"/>
            </el-form-item>
            <el-form-item label="状态：">
              <el-select v-model="query.status" clearable placeholder="请选择">
                <el-option
                  v-for="item in $enums.activityBannerStatus.getList()"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="queryCollection">查询</el-button>
            </el-form-item>
            <el-form-item style="position: absolute;top: 10px;right: 0">
              <router-link :to="{ name: 'activity-activity-pagesetting-carousel-create', query: { activityId: activity ? activity.id : 0 }}">
                <el-button type="primary">添加轮播图</el-button>
              </router-link>
            </el-form-item>
          </el-form>
          <el-table class="table block" :header-cell-style="tableHeaderStyle" v-loading="loading" :data="collection">
            <el-table-column align="center" label="轮播缩略图" width="300">
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.path"
                  :src="scope.row.pathUrl"
                  :preview-src-list="handleImagePreview(scope.row)"
                  alt="加载失败"
                  style="width: 128px;height: 128px"
                  fit="contain"></el-image>
                <el-image v-else style="width: 128px;height: 128px">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="name" label="轮播图名称" width="auto"/>
            <el-table-column align="center" prop="weight" label="权重" width="100"/>
            <el-table-column align="center" label="时间" :formatter="formatTime" width="300" class-name="table-time"/>
            <el-table-column align="center" label="状态" width="150">
              <template slot-scope="scope">
                <span :style="formatStatus(scope.row, 2)" >{{formatStatus(scope.row, 1)}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="200">
              <template slot-scope="scope">
                <router-link :to="{ name: 'activity-activity-pagesetting-carousel-edit', query: { activityId: activity ? activity.id : 0 }, params: { id: scope.row.id }}">
                  <el-button type="text" style="margin-right: 10px">编辑</el-button>
                </router-link>
                <el-button type="text" @click="remove(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination :total="total" :pagination="pagination" :changed="queryCollection" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="本月主打" name="flagship">本月主打</el-tab-pane>
      <el-tab-pane label="商品推荐" name="recommend">商品推荐</el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import moment from 'moment'
  const { mapGetters } = createNamespacedHelpers('activityBanners')

  export default {
    data() {
      return {
        tabName: 'carousel-list',
        activity: null,
        loading: false,
        query: {
          name: '',
          status: ''
        }
      }
    },
    computed: {
      ...mapGetters(['collection', 'total', 'pagination'])
    },
    methods: {
      handleClick(tab) {
        if (tab.name != this.tabName) {
          this.$router.push({ name: 'activity-activity-pagesetting-' + tab.name, query: { activityId: this.activity.id }})
        }
      },
      handleLeave() {
        return false
      },
      tableHeaderStyle(){
        return 'height:54px;font-size:14px;font-wight:500;color:#000;background-color:#f9f9f9;border-bottom:1px solid #e8e8e8;'
      },
      async queryCollection({ pagination = {limit: 5} } = {}) {
        const query = {
          ...this.query,
          activityId: this.activity.id,
          name: this.query.name ? `%${this.query.name}%` : undefined
        }
        this.parseStatusQuery(query)
        try {
          this.loading = true
          const sorts = { weight: 'desc', id: 'desc' }
          await this.$store.dispatch('activityBanners/collection', { query, sorts, pagination })
        } finally {
          this.loading = false
        }
      },
      formatStatus (banner, mode) {
        const statusEnums = this.$enums.activityBannerStatus
        const now = moment()
        const startTime = moment(banner.startTime)
        const endTime = moment(banner.endTime)
        let status = ''
        let style = ''
        if (now.isAfter(endTime)) {
          status = statusEnums.COMPLETE
          style = 'color:gray'
        } else if (now.isBefore(startTime)) {
          status = statusEnums.PENDING
          style = 'color:blue'
        } else {
          status = statusEnums.ONGOING
          style = 'color:green'
        }
        if (mode == 1) {
          return this.$enums.activityBannerStatus.label(status)
        } else {
          return style
        }
      },
      formatTime (banner) {
        const startTime = moment(banner.startTime).format('YYYY-MM-DD HH:mm')
        const endTime = moment(banner.endTime).format('YYYY-MM-DD HH:mm')
        return startTime + ' — ' + endTime
      },
      parseStatusQuery(query) {
        const statusEnums = this.$enums.activityBannerStatus
        const now = moment().format('YYYY-MM-DD HH:mm:ss')
        switch (query.status) {
          case statusEnums.PENDING:
            query.startTime = `>${now}`
            break
          case statusEnums.ONGOING:
            query.startTime = `<=${now}`
            query.endTime = `>=${now}`
            break
          case statusEnums.COMPLETE:
            query.endTime = `<${now}`
            break
        }
        delete query.status
      },
      async remove(banner) {
        await this.$confirm('确定删除当前轮播图？删除操作不可逆，请谨慎操作！', '提示', {
          type: 'warning'
        }).then(async () => {
          try {
            this.loading = true
            await this.$store.dispatch('activityBanners/remove', banner)
            this.$message.success('删除成功')
          } catch (err) {
            this.$message.error('删除失败')
          } finally {
            this.loading = false
            this.queryCollection()
          }
        }).catch(() => {
          return false
        })
      },
      handleImagePreview(banner) {
        return [banner.pathUrl]
      }
    },
    async mounted() {
      const { activityId = 0 } = this.$route.query
      try {
        const { document } = await this.$store.dispatch('activities/document', activityId)
        this.activity = document
      } catch (err) {
        this.$message.error('活动不存在')
        this.$router.push({ name: 'activity-activity' })
      }
      this.queryCollection()
    },
    activated() {
      this.queryCollection()
    }
  }
</script>
